export function readCookie(name) {
    const entries = (document.cookie || "").split(";");

    for (let i = 0; i < entries.length; i++) {
        const [rawName, ...rawValue] = entries[i].split("=");

        if (decodeURIComponent(rawName.trim()) !== name) continue;

        return decodeURIComponent(rawValue.join("=").trim());
    }

    return "";
}
